import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Globals, ReLoadSession } from '@ipreo/muni-shared';
import { Store } from '@ngrx/store';

@Injectable()
export class GamedayDirectAuthInterceptor implements HttpInterceptor {
  constructor(private readonly globals: Globals, private store: Store<Record<string, unknown>>) { }

  public intercept<T>(
    request: HttpRequest<T>,
    next: HttpHandler
  ): Observable<HttpEvent<T>> {
    const token: string = this.globals.localStorage.getItem('token');
    const refreshTimeIsoString: string = this.globals.localStorage.getItem('refreshTime');
    const refreshTime = new Date(refreshTimeIsoString);

    if (refreshTime < new Date()) {

      const currentDate = new Date();
      const tokenValidityInHours = 7
      currentDate.setHours(currentDate.getHours() + tokenValidityInHours);
      localStorage.setItem('refreshTime', currentDate.toISOString());

      this.store.dispatch(new ReLoadSession());
    }

    if (request.headers.has('Authorization')) {
      request =
        request.headers.get('Authorization') === 'none'
          ? request.clone({
            headers: request.headers.delete('Authorization')
          })
          : request;
    } else {
      request = request.clone({
        headers: request.headers
          .append('Authorization', `Bearer ${token}`)
          .append('Content-Type', 'application/json')
          .append('Accept', 'application/json')
      });
    }

    return next
      .handle(request)
      .pipe(catchError(err => this.sessionChecker(err)));
  }

  private sessionChecker(err: any) {
    if (err instanceof HttpErrorResponse && err.status === 401) {
      // ToDo: Handle 401, when requirements come
    }

    return throwError(err);
  }
}
